/**
 * Textos (`es`) del tall «training» de Qualitat i APPCC (OBR-170, formación de manipuladores). Tall propi: no es
 * toca `es.ts`. Las tres lenguas deben tener las mismas claves (i18n.test.ts); ningún texto literal en las vistas.
 */

export const trainingEs = {
  'backoffice.qualityTraining': {
    // Columna y filtro de las listas del Equipo (Usuarios y Operarios).
    columnHeader: 'Formación',
    filterLabel: 'Formación',
    filterAll: 'Todas',
    rowAction: 'Formación',
    openFor: 'Formación de {{name}}',
    // Estado de una persona (derivado de las fechas, nunca guardado).
    statusValid: 'Vigente',
    statusExpiring: 'Caduca pronto',
    statusExpired: 'Caducada',
    statusMissing: 'Sin formación',
    // Temas.
    topicFoodHandler: 'Manipulador de alimentos',
    topicAllergens: 'Alérgenos',
    topicOther: 'Otros',
    // Diálogo de la persona.
    dialogTitle: 'Formación de {{name}}',
    dialogHint:
      'Cursos y certificados de la persona. El estado lo marca la formación que cubre más tiempo; si alguna no caduca, siempre está vigente.',
    dialogStatus: 'Estado',
    empty: 'Todavía no hay ninguna formación registrada.',
    loadError: 'No se han podido cargar las formaciones.',
    readOnly: 'Solo la administración y calidad pueden registrar, editar o dar de baja formaciones.',
    add: 'Añade formación',
    edit: 'Edita',
    remove: 'Da de baja',
    // Una formación en la lista.
    rowTrainedOn: 'Realizada el {{date}}',
    rowProvider: 'Entidad: {{provider}}',
    rowExpiresOn: 'Caduca el {{date}}',
    rowNoExpiry: 'No caduca',
    rowNoCertificate: 'Sin certificado',
    certificateOpen: 'Abre el certificado',
    certificateOpenError: 'No se ha podido abrir el certificado. Vuelve a intentarlo.',
    // Formulario.
    formTitleNew: 'Nueva formación',
    formTitleEdit: 'Edita la formación',
    fieldTopic: 'Tema',
    fieldTopicLabel: 'Qué formación',
    fieldTopicLabelHint: 'Obligatorio cuando el tema es «Otros».',
    fieldTrainedOn: 'Fecha de la formación',
    fieldProvider: 'Entidad o formador',
    fieldExpiresOn: 'Caduca el',
    fieldExpiresOnHint: 'Fecha de renovación. Vacía si la formación no caduca.',
    fieldCertificate: 'Certificado',
    fieldCertificateHint: 'PDF o imagen, hasta 10 MB.',
    certificateCurrent: 'Certificado adjunto',
    certificateNew: 'Nuevo: {{name}}',
    certificateRemove: 'Quita el certificado',
    fieldNotes: 'Notas',
    // Errores de validación y de red (nunca silenciados).
    errorTopicLabelRequired: 'Indica qué formación es.',
    errorTrainedOnRequired: 'Falta la fecha de la formación.',
    errorTrainedOnFuture: 'La fecha de la formación no puede ser futura.',
    errorDateInvalid: 'La fecha no es válida.',
    errorExpiresBeforeTrained: 'La caducidad no puede ser anterior a la fecha de la formación.',
    errorFileType: 'El certificado debe ser un PDF o una imagen.',
    errorFileTooLarge: 'El certificado no puede pasar de 10 MB.',
    errorUpload: 'No se ha podido subir el certificado. Vuelve a intentarlo.',
    errorSave: 'No se ha podido guardar la formación. Vuelve a intentarlo.',
    errorDelete: 'No se ha podido dar de baja la formación. Vuelve a intentarlo.',
    // Baja lógica (motivo obligatorio).
    deleteTitle: 'Da de baja la formación',
    deleteBody:
      'La formación dejará de contar para el estado de la persona. Se conserva en el registro con el motivo.',
    deleteCta: 'Da de baja',
  },
} as const;
